(() => {
    const selector = ".as-widget-destination-button";
    const attribute = "href";
    const value = "#";
  
    function apply(root = document) {
      root.querySelectorAll(selector).forEach((el) => {
        if (el.getAttribute(attribute) !== value) {
          el.setAttribute(attribute, value);
        }
      });
    }
  
    function start() {
      apply();
  
      const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue;
  
            if (node.matches?.(selector)) {
              apply(node.parentNode || document);
            } else if (node.querySelector?.(selector)) {
              apply(node);
            }
          }
        }
      });
  
      obs.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
  
      setTimeout(() => obs.disconnect(), 5000);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start, { once: true });
    } else {
      start();
    }
  })();